import * as React from "react";
import { Container, Dropdown, Accordion, Card, Button ,Form,Spinner,} from "react-bootstrap";

import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../Common/Services/CustomerService";
import { CustomerMasterSlidout } from "../../Modules/Masters/CustomerMasterSlidout";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;
import paginationFactory from 'react-bootstrap-table2-paginator';

import _ from "lodash";
 
import createDOMPurify from "dompurify";
 
import moment from "moment";

  
export class CustomerMaster extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
         
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          customerid:0,
          selectedcolumn: "All",
          selectOptions: [
            { id: 'All', name: 'All'},
            { id: 'Customer Code', name: 'Customer Code' },
            { id: 'Customer Name', name: 'Customer Name' },
            { id: 'Address', name: 'Address' },
            { id: 'Phone Number', name: 'Phone Number' },
          ],
        };
        
     
      }
      
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getCustomerMaster(requestlist);
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let chkisPhoneNumber = id == "Phone Number" ? true : false;
        let chkisaddress = id == "Address" ? true : false;
        let chkiscustomername = id == "Customer Name" ? true : false;
        let chkiscustomercode = id == "Customer Code" ? true : false;
    
    
        if (id == "All") {
          chkisPhoneNumber = true;
          chkisaddress = true;
          chkiscustomername = true;
          chkiscustomercode = true;
    
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isphone_number: chkisPhoneNumber, isaddress: chkisaddress,
          iscompanyname: chkiscustomername, iscustomercode: chkiscustomercode
        },
          () => {
            this.setState({ searcResult: searcResult1 });    
          }
    
    
        );
    
      };
 
      getCustomerMaster = (requestlist: any) => {
 

    CustomerService.GetCustomerlist(requestlist)
    .then(async (result: any[] | null) => {
        
      if (result != null) {
        
        this.setState({ searcResult: result }, () => {
           
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });  
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({ showSlideout: true ,customerid:row.customer_id,isSpinner:false});  
    },
  };
  
  showNewSlideOut = () => {
    this.setState({ showSlideout: true ,customerid:0,isSpinner:false});  
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner:false, });
    let requestlist = { ...this.state.requestlist };
    this.getCustomerMaster(requestlist);
};


  render() {
    const {
      
      showSlideout,
      
  } = this.state;

  const columns = [
    {
      searchable: this.state.iscustomercode,
      dataField: 'customercode',
      text: 'Customer Code',
    },
   
    {
      searchable: this.state.iscompanyname,
      dataField: 'company_name',
      text: 'Customer Name',
      sort: true,
    },
    {
      searchable: this.state.isaddress,
      dataField: 'fullAddress',
      text: 'Customer Address',
    },
    
    
    {
      searchable: this.state.isphone_number,
      dataField: 'phone_number',
      text: 'Phone Number',
    },
     
  ];
    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

            Customer Master
              <div className="action-group d-flex flex-row ml-auto">
                <Button onClick={this.showNewSlideOut}>Add Customer</Button>
              </div>
            </div>

            <section className="mt-3">
            <ToolkitProvider
        keyField="id"
        data={this.state.searcResult}
        columns={columns}

         //className="table table-striped table-borderless align-middle"
        search
      >
        {
          props => (


            <div >
              <section className="d-flex flex-wrap gap-3 pb-2">
                <div className="position-relative">
                  <SearchBar {...props.searchProps} />
                </div>

                <div>
                  <Form.Label>
                    <SingleDropdownListWithoutSearch
                      
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}

                    /></Form.Label>
                </div>

              </section>
              <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list">
                  <BootstrapTable
                    {...props.baseProps}
                    rowEvents={this.rowEvents}
                    keyField="rowId"
                  

                  />
                  </div>
                </div>
            

              </section>
            </div>

          )
        }
</ToolkitProvider>

          </section>

{(showSlideout &&

<CustomerMasterSlidout
closeSlideOut={this.closeSlideOut}
customerid={this.state.customerid}
id={this.state.id}
>


</CustomerMasterSlidout>)}





          </Container>



        </React.Fragment>
      </>
    );
  }
}